.field {
    padding: var(--mantine-spacing-sm) var(--mantine-spacing-md);
    border-bottom: 1px solid var(--mantine-color-default-border);
    flex: 0 0 auto;
}

.trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--mantine-spacing-xs);
    width: 100%;
    padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);
    border: 1px solid var(--mantine-color-default-border);
    border-radius: var(--mantine-radius-sm);
    background: var(--mantine-color-body);
    font-size: var(--mantine-font-size-sm);
}

.trigger:hover {
    background: var(--mantine-color-gray-0);
}

.triggerLabel {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.triggerChevron {
    flex-shrink: 0;
    width: 1rem;
    height: 1rem;
    color: var(--mantine-color-dimmed);
}

.dropdown {
    max-height: 60vh;
    overflow: auto;
}

.group {
    margin-bottom: var(--mantine-spacing-md);
}

.group:last-child {
    margin-bottom: 0;
}

.groupHeading {
    font-size: var(--mantine-font-size-sm);
    margin: 0 0 var(--mantine-spacing-xs) 0;
}

.list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.row {
    padding: var(--mantine-spacing-xs);
    border-radius: var(--mantine-radius-sm);
}

.row:hover {
    background-color: var(--mantine-color-gray-0);
}

.activeRow {
    background-color: var(--mantine-color-gray-0);
    border-left: 2px solid var(--mantine-color-gneis-5);
    padding-left: calc(var(--mantine-spacing-xs) - 2px);
}

.noDocuments {
    display: block;
    color: var(--mantine-color-dimmed);
    font-size: var(--mantine-font-size-sm);
}
